const adminSettings = {
  wecomEmail: {
    cancel: '取消',
    invalidDomains: '请输入完整邮箱域，例如 company.com；不支持 @、通配符或网址，最多 100 个。',
    completePolicy: '请选择用于匹配的企微邮箱，并填写至少一个允许的完整邮箱域。',
    domainsPlaceholder: '例如：company.com\nsubsidiary.com（每行一个，也可用逗号分隔）',
    close: '关闭账号绑定',
    title: '账号绑定',
    titleWithName: '账号绑定 / {{name}}',
    governance:
      '用户首次授权企业邮箱后，系统会直接匹配相同邮箱的已有 AI Hub 账号，完成绑定并登录。账号和邮箱由管理员在组织管理中维护，无需另外登记。',
    mode: '首次绑定方式',
    manual: '暂停自动匹配（仅手动兜底）',
    emailMatch: '企业邮箱匹配',
    field: '用于匹配的企微邮箱',
    selectField: '请选择邮箱字段',
    contactEmail: '通讯录邮箱（email）',
    businessEmail: '企业邮箱（biz_mail）',
    domains: '允许的完整邮箱域',
    domainsHelp:
      '多个邮箱域可每行填写一个，或用英文逗号分隔，例如 jototech.cn, example.com。只填写域名，不加 @，不支持通配符。按完整域精确匹配，子域需单独添加，最多 100 个。',
    savePolicy: '保存设置',
    saved: '已保存',
    failed: '保存失败，请检查邮箱匹配设置后重试。',
    conflict: '配置已变化，请关闭后重新打开，核对最新设置再提交。',
  },
  actions: {
    cancel: '取消',
    confirm: '确认',
    createAdmin: '新建',
    createCredential: '新建凭据',
    delete: '删除',
    disable: '停用',
    edit: '编辑',
    enable: '启用',
    manage: '管理',
    resetPassword: '重置密码',
    retry: '重试',
    save: '保存',
  },
  adminAccounts: {
    columnSelector: {
      label: '选择管理员账号列表列',
      trigger: '列',
    },
    description: '管理后台账号、角色权限和启停状态。',
    createModal: {
      close: '关闭',
      confirm: '创建管理员',
      email: '邮箱地址',
      emailPlaceholder: 'name@company.com',
      mustChangePassword: '首次登录强制修改密码',
      name: '管理员名称',
      namePlaceholder: '请输入管理员名称',
      title: '新建管理员账号',
      validation: {
        emailInvalid: '请输入有效邮箱',
        emailRequired: '请输入邮箱',
        nameRequired: '请输入管理员名称',
      },
    },
    drawer: {
      adminId: '管理员 ID',
      email: '管理员邮箱账号',
      lastActiveAt: '最近活跃时间',
      name: '管理员名称',
      namePlaceholder: '请输入管理员名称',
      role: '角色权限',
      status: '状态',
      titleWithAdmin: '管理管理员账号 / {{name}}',
      validation: {
        nameRequired: '请输入管理员名称',
      },
    },
    empty: '暂无管理员账号',
    resetPasswordModal: {
      close: '关闭',
      confirm: '确认重置',
      description: '确认要重置 {{email}} 的密码吗？',
      impact: '确认后会生成临时密码；旧会话失效，下次登录需改密。',
      title: '确认重置密码',
    },
    role: {
      admin: '管理员',
      superAdmin: '超级管理员',
      unknown: '未设置',
      viewer: '观察员',
    },
    searchLabel: '搜索管理员名称',
    searchPlaceholder: '搜索管理员名称',
    status: {
      active: '活跃',
      banned: '停用',
    },
    sort: {
      createdAtAsc: '按创建时间升序排列',
      createdAtDesc: '按创建时间降序排列',
      lastActiveAtAsc: '按最近活跃时间升序排列',
      lastActiveAtDesc: '按最近活跃时间降序排列',
    },
    table: {
      actions: '操作',
      createdAt: '创建时间',
      email: '管理员邮箱账号',
      lastActiveAt: '最近活跃时间',
      name: '管理员名称',
      role: '角色权限',
      status: '状态',
    },
    title: '管理员账号',
    workspaceLabel: '管理员账号工作区',
  },
  adpCredentials: {
    deleteDialog: {
      close: '关闭',
      confirm: '确认删除',
      failed: '凭据删除失败',
      message: '确认删除“{{name}}”吗？被 ADP 应用引用的凭据无法删除。',
      title: '删除 ADP 凭据',
    },
    description: '集中管理腾讯 ADP 应用复用的腾讯云 SecretId、SecretKey 和接口域名。',
    empty: '暂无 ADP 凭据',
    feedback: {
      createFailed: '凭据创建失败',
      validationFailed: '凭据测试失败',
      validationPassed: '凭据测试通过',
      validationPassedDetail: '凭据连接正常，可访问腾讯 ADP。',
      updateFailed: '凭据更新失败',
    },
    form: {
      close: '关闭',
      create: '创建凭据',
      createSubtitle: '保存后可在创建腾讯 ADP 应用时选择。',
      createTitle: '新建 ADP 凭据',
      editTitle: '编辑 ADP 凭据 / {{name}}',
      fields: {
        name: '凭据名称',
        openapiEndpoint: 'OpenAPI Endpoint',
        region: '腾讯云 Region',
        secretId: 'Tencent SecretId',
        secretKey: 'Tencent SecretKey',
      },
      hideSecret: '隐藏密钥',
      placeholders: {
        name: '例如：生产环境腾讯凭据',
        secretId: '请输入 Tencent SecretId',
        secretKey: '请输入 Tencent SecretKey',
        secretKeyEdit: '留空则保留已保存 SecretKey',
      },
      secretGuide: {
        link: '前往腾讯云 API 密钥管理',
        tooltip: '在腾讯云控制台的访问管理 / API 密钥管理中创建或复制 SecretId 和 SecretKey。',
      },
      secretPreserveHint: '已保存 {{value}}，留空则保留。',
      showSecret: '显示密钥',
      testCredential: '测试连接',
      update: '保存更改',
    },
    loadDescription: 'ADP 凭据加载失败，请稍后重试。',
    loadTitle: '无法加载 ADP 凭据',
    table: {
      actions: '操作',
      endpoint: 'OpenAPI Endpoint',
      name: '凭据名称',
      region: 'Region',
      secretId: 'SecretId',
      updatedAt: '更新时间',
    },
    title: 'ADP 凭据',
    validation: {
      endpointInvalid: 'OpenAPI Endpoint 需以 http:// 或 https:// 开头',
      endpointRequired: '请输入 OpenAPI Endpoint',
      nameRequired: '请输入凭据名称',
      regionRequired: '请输入腾讯云 Region',
      secretIdRequired: '请输入 Tencent SecretId',
      secretKeyRequired: '请输入 Tencent SecretKey',
    },
    workspaceLabel: 'ADP 凭据工作区',
  },
  wecomIdentityProfiles: {
    entry: {
      enabled: '启用身份源',
      title: '企微工作台入口',
      copy: '复制链接',
      copied: '入口链接已复制',
      copyFailed: '复制失败，请选中链接手动复制。',
      help: '填入企业微信自建应用的「应用主页」。请在企业微信内打开，登录后进入应用页。',
    },

    actions: {
      create: '新建身份源',
      deleteReferenced: '有引用，无法删除',
      validate: '测试连接',
    },
    deleteDialog: {
      close: '关闭删除确认',
      confirm: '确认删除',
      message: '确认删除“{{name}}”吗？删除后无法恢复。',
      title: '删除企业微信身份源',
    },
    connection: {
      blocked: '不可用',
      ready: '可用',
    },
    description: '集中管理企业微信 Corp ID、Agent ID 和 App Secret，供应用接入 Bot 时选择。',
    empty: '暂无企业微信身份源',
    feedback: {
      createFailed: '身份源创建失败，请检查配置后重试。',
      createSuccess: '企业微信身份源已创建',
      deleteFailed: '身份源删除失败。请先确认没有 Bot 或身份绑定正在引用。',
      deleteSuccess: '企业微信身份源已删除',
      disableSuccess: '企业微信身份源已停用',
      enableSuccess: '企业微信身份源已启用',
      secretVersionStale: '配置已更新，请刷新后重试。',
      statusFailed: '身份源状态更新失败，请稍后重试。',
      updateFailed: '身份源更新失败，请稍后重试。',
      updateSuccess: '企业微信身份源已更新',
      validateComplete: '身份源检查已完成',
      validateFailed: '无法完成身份源检查，请稍后重试。',
    },
    form: {
      close: '关闭身份源表单',
      create: '创建身份源',
      createSubtitle: '创建后，应用管理员可以在企业微信 IM 对接中选择此身份源。',
      createTitle: '新建企业微信身份源',
      editTitle: '编辑企业微信身份源 / {{name}}',
      fields: {
        agentId: 'Agent ID',
        appSecret: 'App Secret',
        corpId: 'Corp ID',
        name: '身份源名称',
      },
      hideSecret: '隐藏 App Secret',
      identityImmutable: '创建后不可修改。如需更换企业或应用，请新建身份源。',
      placeholders: {
        agentId: '请输入企业微信自建应用 Agent ID',
        corpId: '请输入 ww 开头的企业 ID',
        name: '例如：生产环境企业微信',
        secret: '请输入企业微信自建应用 Secret',
        secretEdit: '已保存，留空表示保留',
      },
      secretPreserveHint: '已保存的 App Secret 不会回显；留空表示保留，输入新值将执行轮换。',
      showSecret: '显示 App Secret',
      update: '保存更改',
    },
    loadDescription: '企业微信身份源加载失败，请稍后重试。',
    loadTitle: '无法加载企业微信身份源',
    permissionDescription: '只有系统管理员可以创建、测试、轮换、停用或删除企业微信身份源。',
    permissionTitle: '无权管理企业微信身份源',
    readiness: {
      actionFallback: {
        blocked: '请修正阻塞配置后重新执行连接测试。',
        unknown: '暂时无法完成测试，请稍后重试。',
      },
      actions: {
        profile_agent_accessible: '请检查 Agent ID 与应用权限后重新测试。',
        profile_agent_active: 'Agent 已停用，请在企业微信后台启用后重试。',
        profile_credential_valid: '请检查 Corp ID、Agent ID 和 App Secret 后重新测试。',
      },
      description: {
        blocked: '配置或平台权限存在明确阻塞，请按提示处理。',
        ready: '凭据有效，企业微信应用可以访问。',
        unknown: '暂时无法完成测试，请稍后重试。',
      },
      status: {
        blocked: '阻塞',
        ready: '就绪',
        unknown: '暂时无法确认',
      },
      title: '连接测试结果',
    },
    references: {
      summary: '{{integrations}} 个 Bot · {{bindings}} 个绑定',
    },
    status: {
      active: '已启用',
      disabled: '已停用',
    },
    table: {
      actions: '操作',
      name: '身份源',
      connection: '连接状态',
      references: '引用',
      status: '状态',
    },
    title: '企业微信身份源',
    validation: {
      agentId: '请输入 Agent ID',
      appSecret: '请输入 App Secret',
      corpId: '请输入 Corp ID',
      name: '请输入身份源名称',
    },
    workspaceLabel: '企业微信身份源工作区',
  },
  common: {
    allStatuses: '全部状态',
  },
  businessNavigation: {
    application: '关联应用',
    applicationHint: '关联后，仅向有应用使用权限且当前渠道已开启的用户显示入口。独立外链可不关联。',
    noApplication: '不关联应用',
    unavailableApplication: '当前关联应用不可用',
    retryApplications: '重新加载应用',
    cardDescription: '启用后，用户侧栏会在“应用中心”下方显示一个固定样式的外部入口。',
    cardTitle: '外部业务入口',
    description: '配置用户侧栏中的单个外部业务系统入口。',
    enabled: '启用业务导航',
    label: '菜单名称',
    labelPlaceholder: '例如：ADP 工作台',
    loadDescription: '业务导航设置加载失败，请稍后重试。',
    loadTitle: '无法加载业务导航',
    preview: '侧栏预览',
    previewHint: '入口固定在应用中心下方，并始终在新标签页打开。',
    previewLabel: '外部工作台',
    save: '保存设置',
    saveFailed: '业务导航保存失败，请检查配置后重试。',
    saved: '业务导航已保存',
    title: '业务导航',
    url: '跳转地址',
    urlHint: '仅支持不包含账号密码的 HTTPS 地址；不要在 URL 中携带 token。',
    validation: {
      labelRequired: '请输入菜单名称',
      labelTooLong: '菜单名称不能超过 20 个字符',
      urlInvalid: '请输入有效的 HTTPS 地址，且不要包含账号密码',
      urlRequired: '请输入跳转地址',
    },
  },
  branding: {
    assetDeleteFailed: '品牌资源删除失败，请稍后重试。',
    assetDeleted: {
      favicon: 'Favicon 已重置为默认图标',
      logo: 'Logo 已重置为默认图标',
    },
    assetNames: {
      favicon: 'Favicon',
      logo: 'Logo',
    },
    assetUploadFailed: '品牌资源上传失败，请检查文件后重试。',
    assetUploaded: {
      favicon: 'Favicon 已上传',
      logo: 'Logo 已上传',
    },
    assetsDescription:
      'Logo 用于登录页和侧边栏品牌区，Favicon 用于浏览器标签页图标；上传后会立即保存。',
    assetsTitle: '品牌资源',
    basicDescription: '设置站点标题与站点描述；站点标题会同步到登录页、侧边栏品牌名和浏览器标题。',
    basicTitle: '基础信息',
    conversationDescription: '配置 Hub Agent 的名称、首页欢迎语和用户消息样式。',
    conversationTitle: '会话体验',
    description: '配置 AI Hub 的站点信息、会话体验和品牌资源。',
    descriptionHint: '用于浏览器描述、登录页辅助说明和后续公开页面展示。',
    emptyAsset: '未设置',
    faviconHint: '建议尺寸：32x32px，支持 ICO、PNG、JPG、WebP、GIF 格式。',
    faviconPreviewAlt: 'Favicon 预览',
    faviconTitle: '网站图标 (Favicon)',
    fields: {
      chatUserBubbleColor: '用户消息气泡色',
      chatUserBubbleColorPicker: '选择用户消息气泡色',
      description: '站点描述',
      hubAgentName: 'Hub Agent 名称',
      hubAgentWelcomeTitle: '首页欢迎标题',
      title: '站点标题',
    },
    hints: {
      chatUserBubbleColor: '全局应用于用户发送的消息；文字会自动切换黑白色以保持可读性。',
      hubAgentName: '最多 20 个字符；留空保存后恢复默认名称 Hub Agent。',
      hubAgentWelcomeTitle: '最多 60 个字符；留空保存后使用当前界面语言的默认欢迎语。',
    },
    loadDescription: '品牌设置加载失败，请稍后重试。',
    loadTitle: '无法加载品牌设置',
    logoHint: '建议尺寸：64x64px，支持 PNG、JPG、WebP、GIF 格式。',
    logoPreviewAlt: 'Logo 预览',
    logoTitle: '网站 Logo',
    placeholders: {
      description: '面向用户展示的产品说明',
      hubAgentName: '例如：Hub Agent',
      hubAgentWelcomeTitle: '例如：今天有什么可以帮你的？',
      title: '例如：AI Hub',
    },
    preview: {
      chatUserBubble: '用户消息预览',
    },
    resetAsset: '重置',
    resetDialog: {
      cancel: '取消',
      close: '关闭',
      confirm: '确认重置',
      message: '确认后当前上传的 {{asset}} 会被移除，预览将恢复为系统默认 Logo。',
      title: '重置品牌资源',
    },
    saveSettings: '保存设置',
    title: '品牌设置',
    uploadAsset: '上传',
    uploadingAsset: '上传中',
    validation: {
      chatUserBubbleColorInvalid: '请输入 #RRGGBB 格式的颜色值',
      hubAgentNameTooLong: 'Hub Agent 名称不能超过 20 个字符',
      hubAgentWelcomeTitleTooLong: '首页欢迎标题不能超过 60 个字符',
      titleRequired: '请输入站点标题',
    },
    workspaceBackground: {
      assetsSection: '素材',
      baseColor: '背景底色',
      cancel: '取消',
      chooseImage: '选择图片',
      composition: '构图参数',
      configure: '配置背景',
      configured: '已配置工作区背景',
      confirmDelete: '确认删除',
      conversationState: '正常对话',
      delete: '恢复默认背景',
      deleteDescription: '当前工作区背景和移动端独立素材都会被移除，用户端恢复默认纯色。',
      deleteFailed: '工作区背景删除失败，请稍后重试。',
      deleted: '工作区背景已恢复默认',
      deleteTitle: '恢复默认工作区背景',
      description:
        '上传一张桌面主图，按真实桌面、笔记本和移动端工作区调整焦点；移动端可选独立素材。',
      devicePreview: '预览设备',
      devices: {
        desktop: '桌面大屏',
        laptop: '笔记本',
        mobile: '移动端',
      },
      displaySection: '显示',
      editorSubtitle: '独立画布编辑 · 所见即运行态',
      emptyState: '空会话',
      enabled: '启用背景',
      horizontalFocus: '水平焦点',
      imageOpacity: '背景可见度',
      imageOpacityHint: '推荐 32% · 可调范围 10%–70%；文字阅读保护由前端独立处理。',
      invalidFile: '请选择 10MB 以内的 PNG、JPEG 或 WebP 图片。',
      mobileConversationMode: '移动端正常对话',
      mobileImage: '移动端独立素材（可选）',
      mobileModes: {
        background: '保留低强度背景',
        base_color: '仅保留底色（推荐）',
      },
      noImage: '尚未选择',
      notConfigured: '尚未配置工作区背景',
      previewBaselines: '桌面 1920×1080 · 笔记本 1440×900 · 移动端 390×844',
      previewState: '预览状态',
      previewConversationAssistant: '你好，我已准备好协助你处理学习与校园事务。',
      previewConversationTitle: '今日学习计划',
      previewConversationUser: '请帮我整理今天的学习计划。',
      previewWelcomeTitle: '今天有什么可以帮你的？',
      primaryImage: '桌面主图',
      removeImage: '移除',
      resetCrop: '重置当前裁切',
      save: '保存并发布',
      saveFailed: '工作区背景发布失败，请检查图片与裁切设置后重试。',
      saved: '工作区背景已发布',
      storedImage: '已发布素材',
      title: '工作区背景',
      verticalFocus: '垂直焦点',
      zoom: '缩放',
    },
  },
  coreAgent: {
    allowedModels: '已选模型',
    defaultModel: '默认模型',
    defaultModelPlaceholder: '请选择默认模型',
    description: '配置 AI Hub 首页的 {{hubAgentName}} 聊天入口。',
    enableDescription: '关闭后，用户端将隐藏 {{hubAgentName}} 入口。',
    enableTitle: '启用 {{hubAgentName}}',
    loadDescription: '{{hubAgentName}} 设置加载失败，请稍后重试。',
    loadTitle: '无法加载 {{hubAgentName}} 设置',
    modelsDescription: '仅已注册且启用的模型可作为 {{hubAgentName}} 候选模型。',
    modelsTitle: '模型',
    modelPicker: {
      allProviders: '全部供应商',
      apply: '应用选择',
      empty: '没有匹配的模型',
      noSelection: '尚未选择模型',
      open: '选择模型',
      otherProvider: '其他供应商',
      providerGroups: '模型供应商分组',
      searchLabel: '搜索模型',
      searchPlaceholder: '搜索模型名称或供应商',
      selectedCount: '已选择 {{count}} 个模型',
      title: '选择模型',
    },
    noModels: '暂无可用注册模型',
    showToolDetails: '显示工具详情',
    showToolDetailsHint: '关闭后，聊天中仍显示工具完成或失败状态，但不再提供输入和输出详情。',
    systemPrompt: '系统提示词',
    systemPromptHint: '该提示词会作为 {{hubAgentName}} 每次对话的 system prompt。',
    systemPromptPlaceholder: 'You are AI Hub global assistant.',
    title: '{{hubAgentName}} 设置',
    viewerNotice: 'Viewer 只能查看 Hub Agent 设置和 Tool 选择。',
    validation: {
      allowedModelsRequired: '启用时至少选择一个模型',
      defaultModelMustBeAllowed: '默认模型必须在允许模型中',
      defaultModelRequired: '启用时请选择默认模型',
    },
  },
  sso: {
    actions: {
      configure: '配置',
      configureProvider: '配置 {{provider}}',
      edit: '编辑配置',
      editProvider: '编辑 {{provider}}',
      test: '测试连接',
    },
    description: '管理成员登录方式，包括 SSO 协议和邮箱密码登录策略。',
    drawer: {
      title: '成员认证 / {{provider}}',
    },
    flow: {
      connectionTitle: '协议连接',
      identityTitle: '账号匹配与创建',
      next: '下一步',
      previous: '上一步',
      progressLabel: 'SSO 配置步骤',
      sections: {
        connection: '协议连接',
        identity: '账号匹配',
      },
      tabsLabel: 'SSO 配置栏目',
    },
    bridge: {
      customSource: '自定义字段',
      customSourceField: '自定义外部字段',
      customSourceHint: '只支持顶层非空 string，不支持嵌套路径、表达式或 fallback。',
      customSourcePlaceholder: '例如 employee_id',
      externalField: '外部身份字段',
      hubField: 'Hub 账号字段',
      mappingHelp:
        '用户首次通过该 SSO 登录时，系统用外部身份字段的值查找 Hub 账号字段。唯一匹配后会建立绑定，后续登录不再重复匹配。已有绑定时，修改这两个字段前需要先迁移身份。',
      mappingTitle: '账号匹配规则',
      targets: {
        email: 'Hub: email',
        external_person_id: 'Hub: external user id',
      },
    },
    autoRedirect: '自动进入企业 SSO',
    autoRedirectDescription:
      '访问用户端 /login 时直接跳转到当前 IdP。固定账号密码入口仍为 /login/password。',
    enableEmail: '邮箱密码登录',
    enableEmailDescription:
      '控制默认 /login 是否显示邮箱密码；固定 recovery 入口 /login/password 始终保留。',
    enableSso: 'SSO 登录',
    enableSsoDescription: '用户登录页展示 SSO 入口，并由当前选中的协议完成身份认证。',
    fields: {
      acs_url: 'ACS URL',
      algorithm: 'Algorithm',
      authorization_endpoint: 'Authorization Endpoint',
      authorization_url: 'Authorization URL',
      cas_base_url: 'CAS 服务地址',
      cas_match_attribute: 'Hub 本地身份字段',
      client_id: 'Client ID',
      client_secret: 'Client Secret',
      end_session_endpoint: 'End Session Endpoint',
      idp_entity_id: 'IdP Entity ID',
      idp_slo_url: 'IdP SLO URL',
      idp_sso_url: 'IdP SSO URL',
      idp_x509_cert: 'IdP x509 Cert',
      issuer: 'Issuer URL',
      jwks_uri: 'JWKS URL',
      logout_redirect_url: 'Logout Redirect URL',
      logout_url: 'Logout URL',
      oauth2_subject_claim: '用户 ID 字段',
      scope: 'Scope',
      sp_entity_id: 'SP Entity ID',
      sp_private_key: 'SP Private Key',
      sp_x509_cert: 'SP x509 Cert',
      token_endpoint: 'Token Endpoint',
      token_url: 'Token URL',
      userinfo_endpoint: 'Userinfo Endpoint',
      userinfo_url: 'Userinfo URL',
    },
    loadDescription: '成员认证设置加载失败，请稍后重试。',
    loadTitle: '无法加载成员认证设置',
    methodsDescription: '控制用户登录页展示哪些登录方式。至少保留一种。',
    methodsTitle: '登录方式',
    placeholders: {
      acs_url: 'https://hub.example.com/v1/api/app/auth/sso/callback',
      algorithm: 'RS256',
      authorization_endpoint: 'https://idp.example.com/oauth2/v1/authorize',
      authorization_url: 'https://idp.example.com/oauth2/authorize',
      cas_base_url: 'https://sso.example.com/cas',
      client_id: 'portal-client-id',
      client_secret: '请输入 client secret',
      end_session_endpoint: 'https://idp.example.com/oauth2/v1/logout',
      idp_entity_id: 'https://idp.example.com/metadata',
      idp_slo_url: 'https://idp.example.com/slo',
      idp_sso_url: 'https://idp.example.com/sso',
      idp_x509_cert: '粘贴 IdP 证书内容',
      issuer: 'https://idp.example.com',
      jwks_uri: 'https://idp.example.com/.well-known/jwks.json',
      logout_redirect_url: 'https://hub.example.com/login',
      logout_url: 'https://idp.example.com/logout',
      oauth2_subject_claim: 'id',
      scope: 'openid profile email',
      secretWithSaved: '已保存 {{value}}，留空则保留',
      sp_entity_id: 'aihub-portal',
      sp_private_key: '粘贴 SP 私钥内容',
      sp_x509_cert: '粘贴 SP 证书内容',
      token_endpoint: 'https://idp.example.com/oauth2/v1/token',
      token_url: 'https://idp.example.com/oauth2/token',
      userinfo_endpoint: 'https://idp.example.com/oauth2/v1/userinfo',
      userinfo_url: 'https://idp.example.com/oauth2/userinfo',
    },
    providers: {
      cas: {
        configuration:
          'CAS 只需配置协议 context URL；Hub 会自动使用 login、serviceValidate 和 logout endpoint。',
        description: '适合兼容 CAS 2.0 的统一身份认证服务。',
        new: '开启 CAS',
        title: 'CAS',
      },
      oauth2: {
        configuration: 'OAuth2 需要授权、token、userinfo endpoint，并明确返回用户唯一 ID 的字段。',
        description: '适合通用 OAuth2 provider。',
        new: '开启 OAuth2',
        title: 'OAuth2',
      },
      oidc: {
        configuration: 'OIDC 需要 issuer、授权、token、userinfo endpoint 和 client secret。',
        description: '适合支持 OpenID Connect 的企业身份源。',
        new: '开启 OIDC',
        title: 'OIDC',
      },
      saml: {
        configuration: 'SAML 需要 IdP、SP、ACS 和证书参数。',
        description: '适合企业级 SAML 2.0 身份源。',
        new: '开启 SAML',
        title: 'SAML',
      },
    },
    providersDescription: '选择 CAS、SAML、OIDC 或 OAuth2 完成成员认证；保存新协议会替换当前协议。',
    providersTitle: 'SSO 协议',
    jit: {
      help: {
        cas: '关闭时，没有唯一匹配账号的用户会被拒绝登录。开启后可自动创建普通成员，但 CAS attributes 必须返回 email、mail 或 userPrincipalName；不会自动授予任何权限。',
        oauth2:
          '关闭时，没有唯一匹配账号的用户会被拒绝登录。开启后可自动创建普通成员，但 OAuth2 UserInfo 必须返回可用邮箱；不会自动授予任何权限。',
        oidc: '关闭时，没有唯一匹配账号的用户会被拒绝登录。开启后可自动创建普通成员，但 OIDC ID Token 或 UserInfo 必须返回可用邮箱；不会自动授予任何权限。',
        saml: '关闭时，没有唯一匹配账号的用户会被拒绝登录。开启后可自动创建普通成员，但 SAML Assertion 必须返回可用邮箱 Attribute；不会自动授予任何权限。',
      },
      title: '自动创建账号（JIT）',
    },
    status: {
      configured: '已配置',
      incomplete: '未完整',
    },
    test: {
      failed: '连接测试失败',
      success: '连接测试通过',
      warning: '连接测试返回警告',
    },
    title: '成员认证',
    updatedAt: '最近更新：{{time}}',
    validation: {
      configRequired: '启用 SSO 前需要先完整配置一个协议。',
      oneLoginRequired: '至少需要保留一种登录方式。',
      redirectRequiresSso: '请先启用 SSO 登录，再开启自动跳转。',
      required: '请填写该字段',
    },
  },
  errors: {
    loadDescription: '管理员账号数据加载失败，请稍后重试。',
    loadTitle: '无法加载管理员账号',
    submitFailed: '操作失败，请稍后重试。',
  },
  mcpRuntime: {
    budgets: {
      description: '限制每次 discovery 与 Tool execution 可占用的总时间和完整响应大小。',
      title: '资源预算',
    },
    close: '关闭 MCP 设置',
    description: '统一管理所有 MCP 服务使用的网络策略与 discovery / execution 资源预算。',
    feedback: {
      updated: 'MCP 设置已更新',
      updateFailed: 'MCP 设置更新失败，请刷新后重试。',
    },
    fields: {
      discoveryTimeoutMs: 'Discovery timeout（毫秒）',
      executionTimeoutMs: 'Execution timeout（毫秒）',
      maxDiscoveryResponseBytes: 'Discovery 最大响应（字节）',
      maxExecutionResponseBytes: 'Execution 最大响应（字节）',
      privateNetworkAllowlist: '私有网络 allowlist',
    },
    globalNotice: '这里的设置会应用于所有 MCP 服务；新增连接自动使用当前值，无需逐条配置。',
    loadDescription: '无法读取全局 MCP runtime policy，请稍后重试。',
    loadTitle: '无法加载 MCP 设置',
    network: {
      description: '公网 HTTP(S) endpoint 可直接连接；私网目标必须在这里统一审核并放行。',
      title: '网络策略',
    },
    placeholders: {
      privateNetworkAllowlist: '每行一个 hostname、IP 或 CIDR',
    },
    title: 'MCP 设置',
    validation: {
      positiveInteger: '请输入正整数。',
    },
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  success: {
    createAdminAccount: '管理员账号已创建',
    createAdpCredential: 'ADP 凭据已创建',
    deleteAdpCredential: 'ADP 凭据已删除',
    resetPassword: '密码已重置',
    updateAdminAccount: '管理员账号已更新',
    updateAdpCredential: 'ADP 凭据已更新',
    updateBrandingSettings: '品牌设置已更新',
    updateCoreAgentSettings: '{{hubAgentName}} 设置已更新',
    updateSsoSettings: '成员认证设置已更新',
    updateStatus: '管理员状态已更新',
  },
  temporaryPassword: {
    account: '账号',
    close: '关闭',
    copied: '已复制',
    copy: '复制',
    copyAccount: '复制账号',
    copyFailed: '复制失败，请手动复制',
    copyPassword: '复制密码',
    password: '密码',
    resetHelp: '旧会话已失效；首次登录需改密；密码仅显示一次。',
    resetTitle: '密码已重置',
    title: '账号已创建',
  },
}

export default adminSettings
